(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-pbw-tab]');
    var panels = root.querySelectorAll('[data-pbw-panel]');
    if (!tabs.length || !panels.length) return;

    root.classList.add('is-ready');

    function activate(type) {
      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-pbw-tab') === type;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-pbw-panel') === type;
        panel.classList.toggle('is-active', selected);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-pbw-tab'));
      });
    });

    activate(tabs[0].getAttribute('data-pbw-tab'));
  }

  function initRails(scope) {
    var controls = scope.querySelectorAll('[data-pbw-scroll]');
    controls.forEach(function (button) {
      button.addEventListener('click', function () {
        var wrap = button.closest('[data-pbw-rail-wrap]');
        if (!wrap) return;
        var rail = wrap.querySelector('[data-pbw-rail]');
        if (!rail) return;
        var direction = button.getAttribute('data-pbw-scroll') === 'next' ? 1 : -1;
        var firstCard = rail.querySelector('.pbw-product-card, .pbw-video-card');
        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var distance = firstCard ? firstCard.getBoundingClientRect().width + gap : 240;
        rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
      });
    });

    scope.querySelectorAll('[data-pbw-rail]').forEach(function (rail) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var didDrag = false;

      rail.addEventListener('pointerdown', function (event) {
        if (event.button !== 0 || event.target.closest('button, input, select, textarea')) return;
        isDown = true;
        didDrag = false;
        startX = event.clientX;
        scrollLeft = rail.scrollLeft;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(event.pointerId);
      });

      rail.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 4) didDrag = true;
        rail.scrollLeft = scrollLeft - delta;
      });

      function endDrag(event) {
        if (!isDown) return;
        isDown = false;
        rail.classList.remove('is-dragging');
        if (rail.hasPointerCapture(event.pointerId)) {
          rail.releasePointerCapture(event.pointerId);
        }
      }

      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('click', function (event) {
        if (!didDrag) return;
        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      }, true);
    });
  }

  function initVideoButtons(scope) {
    scope.querySelectorAll('[data-pbw-video-play]').forEach(function (button) {
      var frame = button.closest('.pbw-video-frame');
      if (!frame) return;
      var video = frame.querySelector('video');
      if (!video) return;
      video.controls = false;
      video.removeAttribute('controls');

      function pauseOtherVideos() {
        document.querySelectorAll('.pbw-video-frame video').forEach(function (otherVideo) {
          if (otherVideo !== video) {
            otherVideo.pause();
          }
        });
      }

      function toggleVideo() {
        if (!video.paused) {
          video.pause();
          return;
        }
        pauseOtherVideos();
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {});
        }
      }

      button.addEventListener('click', function (event) {
        event.stopPropagation();
        toggleVideo();
      });

      video.addEventListener('click', function () {
        toggleVideo();
      });

      video.addEventListener('play', function () {
        pauseOtherVideos();
        frame.classList.add('is-playing');
      });

      video.addEventListener('pause', function () {
        frame.classList.remove('is-playing');
      });

      video.addEventListener('ended', function () {
        frame.classList.remove('is-playing');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pbw-products]').forEach(initTabs);
    initRails(document);
    initVideoButtons(document);
  });
})();
